import { Button, Dialog, Text } from 'braid-design-system';
import { useId } from 'react';

import { useLogin } from '#src/hooks/auth.tsx';

interface LoginPromptProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  redirect: string;
}

export const LoginPrompt = ({ open, setOpen, redirect }: LoginPromptProps) => {
  const { login } = useLogin();
  return (
    <Dialog
      width="small"
      id={useId()}
      title="Login"
      open={open}
      onClose={() => setOpen(false)}
    >
      <Text>
        It appears you are not logged in. Log in to pre-fill some details and
        enable SEEK to respond more quickly depending on the details provided.
      </Text>
      <Button
        onClick={() => {
          login({
            returnTo: redirect,
          });
          setOpen(false);
        }}
        tone="formAccent"
      >
        Login
      </Button>
    </Dialog>
  );
};
